export default class PaginatedResponse {
  readonly items: Array<any>;
  readonly totalItems: number;
  readonly itemsPerPage: number;

  constructor(items: Array<any>, totalItems: number, itemsPerPage: number) {
    this.items = items;
    this.totalItems = totalItems;
    this.itemsPerPage = itemsPerPage;
  }
}
